<div class="container">
    <div class="zoom-container">
        <div id="meetingSDKElement">
            <!-- Zoom Meeting SDK Rendered Here -->
            </div>
    </div>
</div>